<style lang="scss">
// https://codepen.io/jczimm/pen/vEBpoL
@import '~scss/_variables';

.google-loader {
    display: flex;
    width: 60px;
    margin: 0 auto;
    position: relative;

    &.accent-1 {
        .path {
            stroke: $color-accent-1;
        }
    }

    .circular {
        width: 100%;
        height: 100%;
        margin: auto;
        transform-origin: center center;
        animation: google-loader-rotate 2s linear infinite;
    }

    .path {
        animation: google-loader-dash 1.5s ease-in-out infinite;
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        stroke-linecap: round;
        stroke-width: 4px;
        stroke: $color-background-1;
    }
}

@keyframes google-loader-rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes google-loader-dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }
    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
}
</style>

<template>
    <div class="google-loader" :class="classList">
        <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" fill="none"/>
        </svg>
    </div>
</template>

<script>
export default {
    props: ['classList']
};
</script>
